<template>
<div>
    
    <el-dropdown>
  <span class="el-dropdown-link">
    <el-avatar shape="square" :size="40" :src="squareUrl" fit="cover"></el-avatar>

    &nbsp;&nbsp;{{currentUser.name}}
    <i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item><router-link to="/userCenter" style="text-decoration: none;">个人中心</router-link> </el-dropdown-item>
    <el-dropdown-item @click.native="logout">安全退出</el-dropdown-item> 
  </el-dropdown-menu>
</el-dropdown>
</div>
</template>
<script>
import router from '@/router';
import store from '@/store';
import { watch } from 'vue';
export default{
        name: "AvatarView",
        data(){
            return {
                currentUser:{},
                squareUrl:'',
            }
        },
        mounted(){
             this.currentUser = JSON.parse(window.sessionStorage.getItem('currentUser'))
             this.squareUrl = this.$store.state.avator
             watch(this.$store.state,()=>{
                this.squareUrl = this.$store.state.avator
                console.log('---------',this.squareUrl);
                
             },{deep:true,immediate:true})
        },
        methods:{
            logout(){
                this.$message.info('退出登录')
                window.sessionStorage.clear()
                store.commit('SET_TAB')
                router.replace('/login')
            },
        },
    }
    
</script>

<style lang="scss" scoped>
.el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
}
::v-deep .router-link-active {
 text-decoration: none
}
::v-deep .el-avatar>img {
    width: 100%;
}
</style>